function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M0 1.5h12"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.657 9.657L6.464 4.464 6 4l-.243-.243L.1 9.414l.707.707 4.95-4.95 5.193 5.193.707-.707z",
  fill: "currentColor"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgArrow;